import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { SubtitleText } from "common/Components/BulkEditTagsDialog/BulkEditTagsDialog.styles";

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: 440,
    padding: 0,
    height: "100%",
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

export const DrawerColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  minWidth: 0,
  overflow: "hidden",
});

export const DrawerHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: theme.spacing(1),
  flexShrink: 0,
  minWidth: 0,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const DrawerHeaderMain = styled(Box)({
  minWidth: 0,
  flex: 1,
});

export const DrawerTitle = styled(Typography)({
  fontWeight: 600,
});

export const DrawerSelectedText = styled(Typography)({
  wordBreak: "break-word",
  overflowWrap: "anywhere",
});

export const DrawerScrollBody = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const DetailsReadOnlyStack = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const EditableFieldsHeading = styled(SubtitleText)(({ theme }) => ({
  fontWeight: 600,
}));

export const ReadOnlyFieldRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: theme.spacing(1),
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
  minWidth: 0,
}));

export const ReadOnlyFieldMain = styled(Box)({
  minWidth: 0,
  flex: 1,
});

export const ReadOnlyFieldValue = styled(Typography)({
  wordBreak: "break-word",
  overflowWrap: "anywhere",
});

export const ReadOnlyFieldCopyButton = styled(Box)({
  flexShrink: 0,
});

export const DrawerFooter = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));
